module.exports = __webpack_public_path__ + "static/img/product_2.b4bf79d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/product_2.png
// module id = AUvI
// module chunks = 15